<div class="row">
    <div class="col-2 d-flex justify-content-center">
        <audio #audioPlayer src="{{source}}" (ended)="ended()" ></audio>
        <div #audioPlayerToggler class="audio-player paused" (click)="togglePlayer()">
            <div class="icon"></div>
            <div class="label"></div>
        </div>
    </div>
    <div class="col-10 text-large" [innerHTML]="transcript" ></div>
</div>